import React from "react";
import { Menubar } from 'primereact/menubar';
import PropTypes from "prop-types";

function SubMenu({ list }) {
	return (
		<div className="sub-nav">
			<div className="sub-nav--inner">
            	<Menubar model={list} breakpoint="960px" />
			</div>
		</div>
	);
}

SubMenu.propTypes = {
    list: PropTypes.array.isRequired
}

export default SubMenu;
